import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Divider, Skeleton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Card from "../../../components/ui/Card";
import { useSelector } from "react-redux";
import { RootState } from "../../../services/redux/store";

import service from "../../../services/api/service"; // API service
import { formatDate } from "../../../utils/dateFormatUtils";
import {
  formatIndianRupees,
  formatNormalIndianRupees,
} from "../../../utils/formatting";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface Item {
  accountNumber: string;
  totalAmount: number;
  status: string;
  initiatedBy: string;
  requested: string;
  disbursed: string;
  amount: string;
  requestAt: string;
  purpose: string;
  trackingId: string;
  requestId: string;
  amountPaid: string;
}

const ItemCard = ({
  item,
  isLoading,
  handleActionClick,
}: {
  item: Item;
  isLoading: boolean;
  handleActionClick: any;
}) => (
  <Box mb={2}>
    <Card>
      <Grid
        container
        className="dashboard-container-mobile"
        style={{ marginBottom: "7px" }}
      >
        <Grid item xs={9} sm={10} sx={{ marginBottom: "5px" }}>
          <span className="insidePageLableMobile label-blue-color"> Date </span>{" "}
          <span className="insidePageValueCardItemMobile">
            {" "}
            {formatDate(item.requestAt)}{" "}
          </span>
        </Grid>
        <Grid
          item
          xs={3}
          sm={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "5px",
          }}
        >
          <span
            className="insidePageLableMobile label-blue-color pointer"
            style={{ display: "flex", alignItems: "center" }}
            onClick={() => handleActionClick(item?.requestId)}
          >
            View Status{" "}
            <ArrowForwardIosIcon
              style={{ marginLeft: "5px", fontSize: "10px" }}
            />
          </span>
        </Grid>

        <Grid item xs={5} sm={5}>
          <Typography
            className="insidePageLableMobile"
            sx={{ marginBottom: "5px" }}
          >
            {" "}
            Request ID{" "}
          </Typography>
          <Typography className="insidePageValueCardItemMobile">
            {" "}
            {item.requestId}{" "}
          </Typography>

        </Grid>

        <Grid item xs={4} sm={4}>
          <Typography
            className="insidePageLableMobile"
            sx={{ marginBottom: "5px" }}
          >
            {" "}
            Tracking ID{" "}
          </Typography>{" "}
          <Typography className="insidePageValueCardItemMobile">
            {" "}
            {item.trackingId}{" "}
          </Typography>
        </Grid>

        <Grid item xs={3} sm={3}>
          <Typography
            className="insidePageLableMobile"
            sx={{ marginBottom: "5px" }}
          >
            {" "}
            Initiated By{" "}
          </Typography>
          <Typography className="insidePageValueCardItemMobile">
            {" "}
            {item.initiatedBy}{" "}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <Grid
        container
        className="dashboard-container-mobile"
        style={{ marginBottom: "7px" }}
      >
        <Grid item xs={4} sm={4}>
          <Typography
            className="insidePageLableMobile"
            sx={{ marginBottom: "5px" }}
          >
            Purpose
          </Typography>
          <Typography
            className="insidePageValueCardItemMobile"
            sx={{ fontSize: "13px !important" }}
          >
            {item.purpose}
          </Typography>
        </Grid>

        <Grid item xs={4} sm={4}>
          <Typography
            className="insidePageLableMobile"
            sx={{ marginBottom: "5px" }}
          >
            Amount Paid
          </Typography>
          <Typography
            sx={{ fontSize: "13px !important" }}
            className={`insidePageValueItemMobile label-green-color `}
          >
            {formatNormalIndianRupees(Number(item?.amountPaid))}
          </Typography>
        </Grid>

        <Grid item xs={4} sm={4}>
          <Typography
            className="insidePageLableMobile"
            sx={{ marginBottom: "5px" }}
          >
            Total Amount
          </Typography>
          <Typography
            className="insidePageValueItemMobile"
            sx={{ fontSize: "13px !important" }}
          >
            {formatNormalIndianRupees(Number(item?.totalAmount))}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  </Box>
);

const CardItemTermPayment = ({ rows, isLoading, handleActionClick }: any) => {
  const [responseReceived, setResponseReceived] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setResponseReceived(true);
    }
  }, [isLoading]);
  return (
    <div>
      {responseReceived ? (
        rows?.length === 0 ? (
          <Typography variant="h6" align="center" className="no-records-found">
            No records found
          </Typography>
        ) : (
          rows?.map((item: any) => (
            <ItemCard
              key={item.accountNumber}
              item={item}
              isLoading={isLoading}
              handleActionClick={handleActionClick}
            />
          ))
        )
      ) : (
        <Typography variant="h6" align="center" className="no-records-found">
          Loading...
        </Typography>
      )}
    </div>
  );
};

export default CardItemTermPayment;
